import { render, staticRenderFns } from "./dragBox.vue?vue&type=template&id=0b3436aa&scoped=true&"
import script from "./dragBox.vue?vue&type=script&lang=js&"
export * from "./dragBox.vue?vue&type=script&lang=js&"
import style0 from "./dragBox.vue?vue&type=style&index=0&id=0b3436aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3436aa",
  null
  
)

export default component.exports